import React from "react";
import { formatCurrency } from "../../../../utils/CheckoutPage/priceUtils";

// ============================================================
// COMPONENT
// ============================================================

const PriceSummary = ({
  pricePlan,
  priceBreakdown = null,
  isRecalculating = false,
  isFreeTrial = false,
}) => {
  if (!pricePlan) {
    return null;
  }

  const currency = pricePlan.currency || "USD";

  // ============================================================
  // PRICE BREAKDOWN
  // ============================================================

  const breakdown = priceBreakdown || pricePlan.price_breakdown;

  if (!breakdown) {
    return null;
  }

  const amount = Number(breakdown.amount || 0);

  const discountAmount = Number(breakdown.discount_amount || 0);

  const subTotal = Number(breakdown.sub_total || 0);

  const taxRate = Number(breakdown.tax_rate || 0);

  const taxAmount = Number(breakdown.tax_amount || 0);

  const finalAmount = Number(breakdown.grand_total || 0);

  const hasTax = taxRate > 0;

  // ============================================================
  // FREE TRIAL
  // ============================================================

  const usualPrice = amount;

  // const trialDiscount = isFreeTrial ? Math.max(0, amount - finalAmount) : 0;
  const trialDiscount = isFreeTrial ? discountAmount : 0;

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div className='checkout-prices position-relative'>
      {isFreeTrial ? (
        <>
          {/* ================================================== */}
          {/* USUAL PRICE */}
          {/* ================================================== */}

          <div className='checkout-price-row'>
            <span className='text-decoration-line-through text-muted'>
              Usual price
            </span>

            <span className='text-decoration-line-through text-muted'>
              {formatCurrency(usualPrice, currency)}
            </span>
          </div>

          {/* ================================================== */}
          {/* TRIAL DISCOUNT */}
          {/* ================================================== */}

          <div className='checkout-price-row'>
            <span>Trial discount</span>

            <span>- {formatCurrency(trialDiscount, currency)}</span>
          </div>

          {/* ================================================== */}
          {/* DUE TODAY */}
          {/* ================================================== */}

          <div className='checkout-price-total'>
            <span>Due today</span>

            <span>{formatCurrency(finalAmount, currency)}</span>
          </div>
        </>
      ) : (
        <>
          {/* ================================================== */}
          {/* SUB TOTAL */}
          {/* ================================================== */}

          <div className='checkout-price-row'>
            <span>{hasTax ? "Sub-total (excl. tax)" : "Sub-total"}</span>

            <span>{formatCurrency(subTotal, currency)}</span>
          </div>

          {/* ================================================== */}
          {/* TAX */}
          {/* ================================================== */}

          {hasTax && (
            <div className='checkout-price-row'>
              <span>Tax ({taxRate}%)</span>

              <span>{formatCurrency(taxAmount, currency)}</span>
            </div>
          )}

          {/* ================================================== */}
          {/* FINAL AMOUNT */}
          {/* ================================================== */}

          <div className='checkout-price-total'>
            <span>Final amount</span>

            <span>≈ {formatCurrency(finalAmount, currency)}</span>
          </div>
        </>
      )}

      {/* ================================================== */}
      {/* RECALCULATING */}
      {/* ================================================== */}

      {isRecalculating && (
        <div className='checkout-price-loading'>
          <div className='spinner-border spinner-border-sm' role='status'>
            <span className='visually-hidden'>Calculating...</span>
          </div>

          <span>Calculating...</span>
        </div>
      )}
    </div>
  );
};

export default PriceSummary;
